module.exports = __webpack_public_path__ + "static/media/background.93b79d54.png";